/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Quantity_FertilizingInputs */

const vi_care_log_quantity_fertilizing = /** @type {(inputs: Care_Log_Quantity_FertilizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hàm lượng (kg/ml)`)
};

/**

* @param {Care_Log_Quantity_FertilizingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_quantity_fertilizing = /** @type {((inputs?: Care_Log_Quantity_FertilizingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Quantity_FertilizingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_quantity_fertilizing(inputs)
});